import { useState, useEffect } from "react";
import axios from "axios";

function useFetchArr(url){
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const token = "c2W1upHDo1S71WQtJ07fVuiGLAuYHo"
    useEffect(()=>{
        if(!url) return;

        const controller = new AbortController()
        async function fetchData(){
            try{
                const response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'no-encryption': 'true'
                    },
                    signal: controller.signal}
                );
                // console.log("logging response.data: ",response.data.data[0].detail)
                if(Array.isArray(response.data.data[0].detail)){
                    setData(response.data.data[0].detail);
                }
                else throw new Error("Expected array in response")
            }
            catch (err){
                if(!axios.isCancel(err)){
                    setError(err.message || 'Error fetching data');
                }
            }
        }

        fetchData();
        return ()=>controller.abort();  

    }, [url])

    return {data, error}
}

export default useFetchArr;